import React from "react";

import svg from "../../assets/images/icons/cut.svg";

export const CutIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Cut"}
    />
);
